import { gsap } from 'gsap';

const rotateText = () => {
  const words = document.querySelectorAll('.rotate-text .word');
  const staticText = document.querySelector('.static-text');
  const tl = gsap.timeline({ repeat: -1 });

  gsap.from(staticText, {
    autoAlpha: 0,
    y: 20,
    ease: 'power4.out'
  });

  words.forEach((word) => {
    tl.from(word, {
      autoAlpha: 0,
      y: -20,
      ease: 'power4.out'
    });
    tl.to(word, {
      // delay: 1,
      autoAlpha: 0,
      y: 20,
      ease: 'power4.in'
    });
  });
};

export default rotateText;
